import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import _uniqueId from 'lodash/uniqueId';

import { Icon } from '../../elements';

import styles from './Tooltip.module.scss';

const Tooltip = ({ content }) => {
    const tooltipId = _uniqueId('tooltip_');

    return (
        <div>
            <button type="button" className={styles.button} data-tip data-for={tooltipId}>
                <Icon name="tooltip" size="22" />
                <ReactTooltip id={tooltipId} type='dark' effect='solid' place="right" backgroundColor="#595858" className={styles.wrapper}>
                    <p className={styles.tooltipText}>{content}</p>
                </ReactTooltip>
            </button>
            
        </div>
    )
}

Tooltip.propTypes = {
    content: PropTypes.string.isRequired,
}

export default Tooltip
